import type {
  CallbackFn,
  DatabaseService,
  GetOptions,
  PrestigeConfiguration,
  PrestigeConfigurationData,
  PrestigeConfigurationRepository,
} from '@core';
import {
  migrateLegacyPrestigeTexturesFromFirestore,
  prestigeConfigurationSchema,
} from '@core/entities/prestige-configuration';
import { DatabaseCollection } from './config';
import { getGenericRepository } from './generic-repository';

const parse = (data: unknown): PrestigeConfiguration =>
  prestigeConfigurationSchema.parse(
    migrateLegacyPrestigeTexturesFromFirestore(data),
  );

export const getPrestigeConfigurationRepository = (
  databaseService: DatabaseService,
): PrestigeConfigurationRepository => {
  const repository = getGenericRepository<
    PrestigeConfiguration,
    PrestigeConfigurationData
  >(() => DatabaseCollection.PRESTIGE_CONFIGURATIONS, databaseService);

  return {
    ...repository,
    async get(payload: { id: string }) {
      const result = await repository.get(payload);
      return result ? parse(result) : null;
    },
    async getAll(payload: GetOptions) {
      const result = await repository.getAll(payload);
      return result.map((entry) => parse(entry));
    },
    subscribe(payload: { id: string; callback: CallbackFn<PrestigeConfiguration> }) {
      return repository.subscribe({
        ...payload,
        callback: (entry) => {
          if (!entry) {
            payload.callback(null);
            return;
          }

          payload.callback(parse(entry));
        },
      });
    },
  };
};
